<script>
export default {
  name: "FeatureBlock",
  data () {
  },
  props: {
    fallbackImage: {
      type: String,
      default: null
    },
    hasImage: {
      type: Boolean,
      default: false
    },
    imageAreaBackground: {
      type: String,
      default: null
    }
  }
}
</script>

<template>
  <div class="feature-block">
    <template v-if="hasImage">
      <div
          class="feature-block-image"
          :style="imageAreaBackground"
      >
        <slot name="image" />
      </div>
    </template>
    <div class="feature-block-content">
      <h4 class="article-section-sub-title mb-2">
        <slot name="title" />
      </h4>
      <p class="article-body">
        <slot name="content" />
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.feature-block{
  box-shadow: rgba(0, 0, 0, 0.1) 0 10px 50px;
  border-radius: 0.5rem;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @include tablet {
  }
  @include desktop {
  }
  &-content {
    padding: 1rem;
  }
  &-image {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-width: 6rem;
    background-color: $gray-light;
  }
}
</style>